module.exports = __webpack_public_path__ + "img/JBCOM.7b89588e.svg";